<template>
  <div class="game-box">
    <div class="match-address-box" style="text-align: center;">
      <a-table :pagination="false" :rowKey='record=>record.teamId' :columns="columns" :data-source="data">
        <span slot="playerName" slot-scope="text, record">
          <img style="width:50px;height:50px;border-radius:5px;" :src="record.playerHead"/>&ensp;&ensp;{{ text }}
        </span>
      </a-table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BigGameRank',
  components: {
  },
  created () {
    this.findData()
  },
  destroyed () {},
  mounted () {
    // 初始化
  },
  data () {
    return {
      matchId: this.$route.query.matchId,
      programId: this.$route.query.programId,
      columns: [{
        title: '运动员',
        width: '10%',
        dataIndex: 'playerName',
        scopedSlots: { customRender: 'playerName' }
      },
      {
        title: '队伍名称',
        width: '10%',
        dataIndex: 'teamName'
      },
      {
        title: '进球数',
        width: '10%',
        dataIndex: 'goal'
      },
      {
        title: '乌龙球数',
        align: 'center',
        width: '10%',
        dataIndex: 'ownGoal'
      }],
      data: []
    }
  },
  methods: {
    findData () {
      this.$api.battle.footballGoalRank({matchId: this.matchId}).then(res => {
        if (res.status === 0) {
          this.data = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.match-show-box {
  width: 1200px;
  margin: 0 auto;
  height: 30px;
}
.show-curr {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #434343;
  color: white;
  float: left;
  margin-right: 20px;
  cursor: pointer;
}
.show-nocurr {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #ccc;
  color: white;
  float: left;
  margin-right: 20px;
  cursor: pointer;
}
.game-box{
  min-height: 300px;
}
.font-address-curr {
  font-weight: bold;
  font-size: 20px;
  background: #b80000;
  color: #fff;
  min-width: 100px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 5px;
}
.address-right {
  float: left;
  margin-right: 22px;
  cursor: pointer;
  margin-bottom: 20px;
}
.font-address {
  font-weight: bold;
  font-size: 20px;
  background: #eeeeee;
  color: #999999;
  min-width: 100px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 5px;
}
.match-address-box {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 20px;;
}
.day-box {
  width: 100px;
  height: 100px;
  float: left;
  cursor: pointer;
}
.match-time-box {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  height: 100px;
  margin-top: 20px;
  position: relative;
  background-image: url(../../assets/dayline.png);
  background-size: 94% 2%;
  background-repeat: no-repeat;
  background-position-y: 39px;
  background-position-x: 36px;
}
.line-left {
  cursor: pointer;
  position: absolute;
  top: 24px;
  left: 0px;
  font-size: 30px;
  color: #a0a0a0;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  text-align: center;
  line-height: 21px;
  border: 1px solid #a0a0a0;
}
.line-right {
  position: absolute;
  top: 24px;
  right: 0px;
  font-size: 30px;
  color: #a0a0a0;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 21px;
  border-radius: 100%;
  cursor: pointer;
  border: 1px solid #a0a0a0;
}
.day-font {
  width: 100%;
  height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #999999;
  text-align: center;
}
.day-font-curr {
  width: 100%;
  height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #b41000;
  text-align: center;
}
.day-curr {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 4px solid #b41000;
  margin-left: 37px;
  background: white;
}
.day-nocurr {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 4px solid #ccc;
  margin-left: 37px;
  background: white;
}
.chang-font {
  width: 60%;
  height: 25px;
  background: #b41000;
  color: white;
  border-radius: 5px;
  margin-left: 20px;
  margin-top: 7px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/modal/BigGameRank.vue